import axios from "axios";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { Link } from "react-router-dom";

const EmpGoogleLeads = () => {
  const [leads, setLeads] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const leadsPerPage = 5;
  const EmpId = useSelector((state) => state.auth.user);
  const token = EmpId?.token;

  useEffect(() => {
    const fetchLeads = async () => {
      try {
        const { data } = await axios.get(
          `https://crm-generalize.siarasystems.com/api/employe-leads/${EmpId.staff_id}`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setLeads(data);
      } catch (error) {
        console.error("Error fetching leads:", error);
      }
    };

    fetchLeads();
  }, [EmpId]);

  const indexOfLastLead = (currentPage + 1) * leadsPerPage;
  const indexOfFirstLead = indexOfLastLead - leadsPerPage;
  const currentLeads = leads.slice(indexOfFirstLead, indexOfLastLead);

  console.log(currentLeads);

  const handlePageClick = (data) => {
    setCurrentPage(data.selected);
  };

  return (
    <div className="sm:mx-7 mx-2">
      <div className="p-4 mt-6 bg-white rounded-lg shadow-lg">
        <h3 className="mb-4 text-lg font-semibold">Recently Assigned Leads</h3>
        <div className="overflow-x-auto mt-4">
          <table className="min-w-full bg-white border">
            <thead>
              <tr>
                <th className="px-2 sm:px-6 py-2 sm:py-3 border-b-2 border-gray-300 text-xs sm:text-sm">S.no</th>

                <th className="px-2 sm:px-6 py-2 sm:py-3 border-b-2 border-gray-300 text-xs sm:text-sm">Name</th>
                <th className="px-2 sm:px-6 py-2 sm:py-3 border-b-2 border-gray-300 text-xs sm:text-sm">Phone</th>
                <th className="px-2 sm:px-6 py-2 sm:py-3 border-b-2 border-gray-300 text-xs sm:text-sm">
                  Assigned To
                </th>
                <th className="px-2 sm:px-6 py-2 sm:py-3 border-b-2 border-gray-300 text-xs sm:text-sm">
                  Lead Source
                </th>
                <th className="px-2 sm:px-6 py-2 sm:py-3 border-b-2 border-gray-300 text-xs sm:text-sm">
                  Lead Status
                </th>
                <th className="px-2 sm:px-6 py-2 sm:py-3 border-b-2 border-gray-300 text-xs sm:text-sm">
                  Assigned Date
                </th>
              </tr>
            </thead>
            <tbody>
              {currentLeads.length > 10 ? (
                currentLeads.map((lead, index) => (
                  <tr
                    key={lead.id}
                    className={index % 2 === 0 ? "bg-gray-100" : ""}
                  >
                    <td className="px-2 sm:px-6 py-2 sm:py-4 border-b border-gray-200 text-xs sm:text-sm text-gray-800">
                      {currentPage * leadsPerPage + index + 1}
                    </td>

                    <td className="px-2 sm:px-6 py-2 sm:py-4 border-b border-gray-200 text-xs sm:text-sm text-cyan-600 hover:text-cyan-800 underline font-semibold">
                      <Link to={`/employee-lead-single-data/general/${lead.lead_id}`}>
                        {lead.name}
                      </Link>
                    </td>
                    <td className="px-2 sm:px-6 py-2 sm:py-4 border-b border-gray-200 text-xs sm:text-sm text-gray-800">
                      {lead.phone}
                    </td>
                    <td className="px-2 sm:px-6 py-2 sm:py-4 border-b border-gray-200 text-xs sm:text-sm text-gray-800">
                      {lead.staff_name}
                    </td>
                    <td className="px-2 sm:px-6 py-2 sm:py-4 border-b border-gray-200 text-xs sm:text-sm text-gray-800">
                      {lead.leadSource}
                    </td>

                    <td className="px-2 sm:px-6 py-2 sm:py-4 border-b border-gray-200 text-xs sm:text-sm text-gray-800">
                      {lead.lead_status}
                    </td>
                    <td className="px-2 sm:px-6 py-2 sm:py-4 bg-primary-100 text-primary-800 text-xs sm:text-sm text-gray-700">
                      {moment(lead.createdTime)
                        .format("DD MMM YYYY")
                        .toUpperCase()}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td
                    colSpan="15"
                    className="px-2 sm:px-6 py-4 text-center text-xs sm:text-sm text-gray-500"
                  >
                    No Data Available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
        {leads.length > 0 && (
          <div className="mt-4 flex justify-center">
            <ReactPaginate
              previousLabel={"Previous"}
              nextLabel={"Next"}
              breakLabel={"..."}
              pageCount={Math.ceil(leads.length / leadsPerPage)}
              marginPagesDisplayed={2}
              pageRangeDisplayed={3}
              onPageChange={handlePageClick}
              containerClassName={"pagination"}
              activeClassName={"active"}
              pageClassName={"page-item"}
              pageLinkClassName={"page-link"}
              previousClassName={"page-item"}
              nextClassName={"page-item"}
              previousLinkClassName={"page-link"}
              nextLinkClassName={"page-link"}
              breakClassName={"page-item"}
              breakLinkClassName={"page-link"}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default EmpGoogleLeads;
